<template>
  <div class="Head-wrap">
    <div>
      <p class="textCor">宇亨智能医疗物联平台</p>
    </div>
    <div>
      <el-dropdown @command="fullScreen">
        <span class="el-dropdown-link">
          <el-avatar size="small" :src="src"></el-avatar>
          <i
            class="el-icon-caret-bottom el-icon--right"
            style="font-size: 18px; line-height: 28px; color: #0f0f0f"
          ></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item icon="el-icon-user-solid" disabled>{{
            this.userInfo.name
          }}</el-dropdown-item>
          <el-dropdown-item
            icon="el-icon-s-tools"
            divided
            disabled
            command="personalCenter"
            >用户中心</el-dropdown-item
          >
          <el-dropdown-item
            icon="el-icon-camera-solid"
            divided
            command="picture"
            >修改头像</el-dropdown-item
          >
          <el-dropdown-item
            icon="el-icon-unlock"
            divided
            command="changePassword"
            >修改密码</el-dropdown-item
          >
          <el-dropdown-item
            icon="el-icon-full-screen"
            divided
            command="fullScreen"
            >全屏</el-dropdown-item
          >
          <!-- <el-dropdown-item
            icon="el-icon-warning-outline"
            divided
            command="toggleInfoShow"
            >版本信息</el-dropdown-item
          > -->
          <el-dropdown-item icon="el-icon-switch-button" divided command="Out"
            >退出</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <div></div>
    </div>
    <el-dialog title="修改密码" :visible.sync="dialogVisible" width="30%">
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="原密码" prop="oldPass">
          <el-input
            type="password"
            v-model="ruleForm.oldPass"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="pass" required>
          <el-input
            type="password"
            v-model="ruleForm.pass"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass" required>
          <el-input
            type="password"
            v-model="ruleForm.checkPass"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="修改头像" :visible.sync="pictureDialog" width="20%">
      <div style="margin: 0 auto; width: 148px">
        <upload
          :limitCount="1"
          :imgDisabled="imgDisabled"
          v-model="fileObj"
          @delImgPath="delImgPath($event, 'sign')"
          :fileList="fileList"
        >
        </upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pictureDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="版本信息" :visible.sync="infoShow" width="700px">
      <div style="line-height:25px">版本号：V1.0</div>
      <div  style="line-height:25px">版本说明：本软件是基于.net core的各种技术，B/S模式的三层结构设计完成的，由成都宇亨智能科技有限公司独立开发。
本软件的版权属于成都宇亨智能科技有限公司，未经成都宇亨智能科技有限公司的授权许可不得擅自发布或使用该软件。</div>
      <div style="line-height:25px;color: #e6a23c;">警告:本计算机程序受著作权法和国际公约的保护，未经授权擅自复制或散布本程序的部分或全部，将承受严厉的民事和刑事处罚，对已知的违反者将给予法律范围内的全面制裁。</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="toggleInfoShow"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import upload from "./upload";
import axios from "axios";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      pageName: "Head",
      fullscreen: false,
      dialogVisible: false,
      pictureDialog: false,
      infoShow: false,
      userInfo: "",
      ruleForm: {
        pass: "",
        checkPass: "",
        oldPass: "",
      },
      fileList: [],
      fileObj: "",
      imgDisabled: false,
      signList: [],
      rules: {
        oldPass: [{ required: true, message: "请输入原密码", trigger: "blur" }],
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      },
      src: "",
    };
  },
  components: {
    //someComponent
    upload,
  },
  methods: {
    delImgPath() {},
    tologOut() {
      window.utils.storage.remove("userJson");
      this.$router.push("/");
    },
    fullScreen(cm) {
      if (cm === "fullScreen") {
        let element = document.documentElement;
        if (this.fullscreen) {
          if (document.exitFullscreen) {
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        } else {
          if (element.requestFullscreen) {
            element.requestFullscreen();
          } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
          }
        }
        this.fullscreen = !this.fullscreen;
      } else if (cm === "personalCenter") {
      } else if (cm === "changePassword") {
        this.dialogVisible = true;
      } else if (cm === "picture") {
        this.pictureDialog = true;
      } else if(cm==="toggleInfoShow"){
        this.toggleInfoShow()
      }else if (cm === "Out") {
        this.tologOut();
      }
    },
    handleClose() {},
    toggleInfoShow() {
      this.infoShow = !this.infoShow;
    },
    submitForm(formName) {
      let form = new FormData();
      // // 文件对象
      this.fileList = [];
      form.append("objFile", this.fileObj, this.fileObj.name);
      let config = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      this.axios
        .put("/api/File/PutUserImage", form, config)
        .then((res) => {
          this.pictureDialog = false;
          this.userInfo.imageId = res;
          window.utils.storage.setter("userJson", this.userInfo);
          this.src = this.axios.defaults.baseURL + "/api/File/" + res;
          this.getHeadImg(res);
        })
        .catch((e) => {
          this.$notify.error({
            title: "错误警告",
            message: "图片上传失败了请重新上传",
            type: "warning",
          });
          this.pictureDialog = false;
        });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    getHeadImg(id) {
      this.fileList = [];
      let obj = {
        url: this.axios.defaults.baseURL + "/api/File/" + id,
      };
      this.fileList.push(obj);
    },
  },
  mounted() {
    this.userInfo = window.utils.storage.getter("userJson");
    this.getHeadImg(this.userInfo.imageId);
  },
};
</script>

<style lang="scss" scoped>
.Head-wrap {
  height: 100%;
  padding: 0 20px;
  display: flex;
  align-items: center;
  background-color: white;
  justify-content: space-between;
  .textCor {
    color: #000;
  }
  & > div:nth-child(1) {
    display: flex;
    align-items: center;
    img {
      width: 56px;
      height: 50px;
      margin-right: 10px;
    }

    p {
      font-size: 18px;
      font-weight: 700;
    }
  }

  .el-dropdown {
    margin-right: 20px;
    justify-self: flex-end;

    .el-dropdown-link {
      height: 28px;
      display: flex;
      line-height: 28px;
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>
